<template>
	<svg :class="svgClass" aria-hidden="true">
		<use :xlink:href="iconName"></use>
        <text x="20" y="9" text-anchor="middle" dominant-baseline="middle" fill="#fff" :style="tipsStyle" v-if="iconClass=='icon_tips'">{{tips}}</text>
	</svg>
</template>

<script>
export default {
	name: 'svg-icon',
	props: {
		iconClass: {
			type: String,
			required: true
		},
		className: {
			type: String
        },
        tips: {
            type: String
        },
		tipsStyle: {
			type: String,
			default: 'font-weight:bold;font-size:10px;'
		}
	},
	computed: {
		iconName() {
			return `#icon-${this.iconClass}`
		},
		svgClass() {
			if (this.className) {
				return 'svg-icon ' + this.className
			} else {
				return 'svg-icon'
			}
		}
	}
}
</script>

<style scoped>
.svg-icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>
